import { render, staticRenderFns } from "./DetailGridComponent.vue?vue&type=template&id=797ac306&scoped=true&"
import script from "./DetailGridComponent.vue?vue&type=script&lang=js&"
export * from "./DetailGridComponent.vue?vue&type=script&lang=js&"
import style0 from "./DetailGridComponent.vue?vue&type=style&index=0&id=797ac306&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797ac306",
  null
  
)

export default component.exports